import { render, staticRenderFns } from "./AccountCancellation.vue?vue&type=template&id=5c6d6f1a&scoped=true&"
import script from "@/scripts/AccountCancellation/index.js?vue&type=script&lang=js&"
export * from "@/scripts/AccountCancellation/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6d6f1a",
  null
  
)

export default component.exports